import React from "react";
import styled from "styled-components";
import { useDispatch } from "react-redux";
import ACTIONS from "../../store/action";
import { PRIMARY_600, WARNING_50 } from "../../constant/colors";
import { sizes } from "../../constant/styles";
import { WARNING_600 } from "../../constant/colors";
import { useTranslation } from "react-i18next";
import { ReactComponent as WarningTriangleIcon } from "../../assets/svg/Danger-Triangle.svg";

const AlertContainer = styled.div`
  display: flex;
  justify-content: stretch;
  align-items: center;
  align-self: stretch;
  gap: 10px;
  padding: 8px 6px;
  background-color: ${WARNING_50};
  border-radius: 10px;
  width: 100%;
`;

const AlertText = styled.div`
  line-height: 1.5em;
  flex: 1;
  color: ${WARNING_600};
`;

const AlertTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${sizes.small};
`;

const SupportLink = styled.span`
  color: ${PRIMARY_600};
  text-decoration: underline;
  cursor: pointer;
  text-underline-position: from-font;

  &:hover {
    opacity: 0.8;
  }
`;

const ElectronicConsentAlert = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleSupportClick = () => {
    dispatch(ACTIONS.setShowSupport(true));
  };

  return (
    <AlertContainer>
      <WarningTriangleIcon />
      <AlertTextWrapper>
        <AlertText>
          {t("consent.alerts.electronic_consent_disabled")}
          <SupportLink onClick={handleSupportClick} />
        </AlertText>
      </AlertTextWrapper>
    </AlertContainer>
  );
};

export default ElectronicConsentAlert;
